import type { CashierMirrorIncomingMessage, CashierMirrorTransport } from './cashierMirrorTransport.ts'
import { parseDmAppMessageEnvelope } from './parseDmAppMessageEnvelope.ts'

export type CreateAppMessageCashierMirrorTransportOptions = {
  publish: (type: string, payload?: unknown) => void
  subscribe: (handler: (envelope: unknown) => void) => () => void
}

export function createAppMessageCashierMirrorTransport(
  options: CreateAppMessageCashierMirrorTransportOptions
): CashierMirrorTransport {
  const { publish, subscribe } = options

  return {
    publish(type, payload) {
      publish(type, payload)
    },
    subscribe(handler) {
      return subscribe(envelope => {
        const parsed = parseDmAppMessageEnvelope(envelope)
        if (!parsed) {
          return
        }

        const message: CashierMirrorIncomingMessage = {
          type: parsed.type,
          payload: parsed.payload
        }
        handler(message)
      })
    }
  }
}
